import _ from 'lodash';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/eventActions';

class EventPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.shouldUpdateEventDetails = this.shouldUpdateEventDetails.bind(this);
  }

  componentWillMount() {
    if(this.props.eventId) {
      this.props.actions.loadEventDetails(this.props.eventId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.shouldUpdateEventDetails(nextProps)) {
      this.setState({eventDetails: nextProps.eventDetails});
    }
  }

  shouldUpdateEventDetails(nextProps) {
    let p = this.props;
    let updated = p.eventDetailsUpdated !== nextProps.eventDetailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  render() {
    return (this.props.children);
  }
}

EventPage.propTypes = {
  actions: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ]),
  eventDetails: PropTypes.object.isRequired,
  eventDetailsUpdated: PropTypes.number.isRequired,
  eventId: PropTypes.string,
  loading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  const eventId = ownProps.params.eventId;
  return {
    eventId: eventId,
    loading: state.events.loadingEvents,
    eventDetails: state.events.eventDetails,
    eventDetailsUpdated: state.events.eventDetailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventPage);



/** WEBPACK FOOTER **
 ** ./src/containers/events/EventPage.js
 **/